export default {
  "content": "<path d=\"M10.5 7.502v3.125M2.747 13.44c-.721 1.25.18 2.812 1.624 2.812h12.257c1.443 0 2.345-1.562 1.624-2.812L12.124 2.817c-.722-1.25-2.527-1.25-3.249 0L2.747 13.44zm7.753-.313h.006v.006H10.5v-.006z\" stroke=\"var(--Primary-Text-Color)\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "21",
    "height": "20",
    "viewBox": "0 0 21 20",
    "fill": "none"
  }
};